<header
    class="header header--minimised"
    [style.--header-bg]="bgHeader || null"
    [style.--color-nav-border]="borderHeader || null"
    [style.background-color]="bgHeader || null"
    [class.header--minimised-light]="!isDarkBg">
    <div
        class="navbar-top"
        [style.background-color]="bgHeader || null"
        [style.border-bottom]="'1px solid ' + (borderHeader || '#00b1e2')">
        <div class="container--nav">
            <div class="navbar-top__inner">
                <core-brand-logo
                    category="TOP-NAV"
                    [isNotLink]="true"
                    [bgHeader]="bgHeader"
                    [logoUrlOverride]="logoUrl"></core-brand-logo>
            </div>
        </div>
    </div>
</header>
